import React from 'react';
import { LayoutBackground } from '../Layout/LayoutBackground/LayoutBackground.component';
import { Prompt, PromptProps } from '../../components/Prompt/Prompt.component';

export const BluescreenPromptedOne: React.FC<PromptProps> = (props: PromptProps) => {
  return (
    <>
      <LayoutBackground />
      <Prompt {...props} />
    </>
  );
};
